/*
 * @Author: cc
 * @Date: 2020-01-06 21:27:59
 * @LastEditTime: 2021-05-24 18:14:52
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\toBeCompiled\news\editCenterCompiledNews.js
 * @Description:
 */

'use strict';
angular.module('editCenterNewsModule', ['util.ueditor', 'mgcrea.ngStrap.scrollspy']).controller('EditingCenterNewsController', [
    '$scope',
    'beforeonload',
    '$element',
    '$filter',
    '$compile',
    '$window',
    '$state',
    '$timeout',
    '$validation',
    '$q',
    'trsHttpService',
    'initAddMetaDataService',
    'editingCenterAppService',
    'jsonArrayToStringService',
    'modalDialog',
    'initeditctrBtnsService',
    'editingCenterService',
    'storageListenerService',
    'ueditorService',
    'initAppRequiredBtnService',
    'appDictionaryBtnService',
    'filterEditctrBtnsService',
    'editcenterRightsService',
    'editIsLock',
    'trsSelectDocumentService',
    'trsspliceString',
    'sensitiveWordCheckService',
    'editingMediatype',
    'globleParamsSet',
    '$sessionStorage',
    'newMediaService',
    'messagePublishService',
    'appConst',
    function (
        $scope,
        beforeonload,
        $element,
        $filter,
        $compile,
        $window,
        $state,
        $timeout,
        $validation,
        $q,
        trsHttpService,
        initAddMetaDataService,
        editingCenterAppService,
        jsonArrayToStringService,
        modalDialog,
        initeditctrBtnsService,
        editingCenterService,
        storageListenerService,
        ueditorService,
        initAppRequiredBtnService,
        appDictionaryBtnService,
        filterEditctrBtnsService,
        editcenterRightsService,
        editIsLock,
        trsSelectDocumentService,
        trsspliceString,
        sensitiveWordCheckService,
        editingMediatype,
        globleParamsSet,
        $sessionStorage,
        newMediaService,
        messagePublishService,
        appConst
    ) {
        initStatus();
        initData();
        editingCenterAppService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                pictureSize: {},
                newsFormError: [],
                switch: 'manuscriptInfo', //  默认选中稿件信息
                support: {
                    content: '', //  提交给辅助写作的纯文本
                },
                searchOffical: '',
                isCheckSensitiveWords: false,
                zhengwen: false,
                openBtn: true,
                bigFaceSwitch: { status: false },
                sensitiveWordTit: '敏感词校验',
                isSecondReview: false,
                isSignedOrRevoked: false,
                audioVideoidsArray: [],
                isEditDraft: !!$state.params.appmetadataid,
                position: $state.params.appplatform,
                heimaCheckTit: '错别字校对',
                belongChannelTimeout: false, //  等待关联栏目数据加载完成
                uploadingZJSJ: {},
                showVideoAudioDiv: false, //  初始化音视频所需的div
                isFusionEditor: $state.current.name === 'fusionnews', //  是否来自融合编辑器
                isawaitrevise: $state.params.isawaitrevise,
                mediaType: editingMediatype.app,
                appmetadataid: $state.params.appmetadataid,
                hasTitleSynced: false, // 标题是否已经同步给列表标题
            };
            $scope.data = {
                userName: '',
                copyVersion: [],
                relNewsSelectedItems: [],
                relSubjectSelectedItems: [],
                trench: appConst.params.listenStroageKey,
                relSubjectGroup: [], //  相关专题分组
                relSubjectSelectedGroup: [], //  相关专题所选分组
                selectNewArray: [], //  相关新闻选中数据
                selectSubjectArray: [], //  相关专题选中数据
                listStyle: editingCenterAppService.initListStyle('addZTPIC'),
                label: '',
                commentSet: editingCenterAppService.initCommentSet(),
                contributorsOne: editingCenterAppService.initContributorsOne(),
                docGenre: editingCenterAppService.initDocGenre(),
                relevantofficials: [],
                version: [],
                KEYWORDS: [],
                path: {
                    '-1': 'editingCenterFusionPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                versionName: {
                    '-1': 'iwoobjectversionid',
                    '1': 'appobjectversionid',
                    '2': 'wzobjectversionid',
                    '3': 'bzobjectversionid',
                    '4': 'wxobjectversionid',
                },
                selectedVideoArray: [], //  选择的视频
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                listPicRatio: {
                    set: {
                        0: '',
                        1: '',
                        2: '',
                    },
                    practical: {
                        0: '1',
                        1: '1',
                        2: '1',
                    },
                },
                focusRatio: {
                    set: '',
                    practical: '1',
                },
                bigPicRtion: {
                    set: '', //  大图只需要设置的值不需要单独实际值，因为大图使用的是列表图的第一张
                },
                specZtPicRtion: {
                    set: '', // 窄图
                },
                imgSize: '',
                // specialDoc: 0,
            };
            $scope.list = {
                ORIGINAL: '0'
            };
            if ($scope.status.isFusionEditor) {
                $scope.params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'getAPPFusionDoc',
                    sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                };
            } else {
                $scope.params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'getNewsDoc',
                    ChnlDocId: $state.params.appchnldocid,
                };
            }
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            $scope.status.hasVersionTime = !!angular.isDefined($state.params.appchnldocid);
            emitCloseWindow();
            $scope.editFlag = {
                media: 'app',
                docType: 'news',
            };
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            //  当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.newsForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                //  长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; //  返回
        };

        /**
         * [toggleEditor description] 切换编辑器显隐
         * @return {[type]} [description]
         */
        $scope.toggleEditor = function () {
            $scope.status.zhengwen = !$scope.status.zhengwen;
            if ($scope.status.zhengwen) {
                // 隐藏编辑器
                $('.body_manuscript_content').addClass('editorHidden');
            } else {
                $('.body_manuscript_content').removeClass('editorHidden');
            }
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件,并缓存编辑内容
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, { typeName: 'app', saveLocal: true, hascondition: true });
        }

        /**
         * [initData description]初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.status.showVideoAudioDiv = false;
            if (!$scope.status.isFusionEditor) {
                (angular.isDefined($state.params.appchnldocid) ? initEditData() : initNewData()).then(function () {
                    if (!$scope.data.imgSize && $scope.list) {
                        changeMode($scope.list.LISTSTYLE || '0');
                    }
                    getZrbj();
                    beforeonload.beforeonloadAlert($scope);
                });
                editcenterRightsService.getRightsofBigFace($state.params.appsiteid, 'appsite.trace').then(function (data) {
                    $scope.status.bigFaceRights = !!data['appsite.trace.chakan'] ? 'true' : 'false';
                });
                initBtnArray();
                // 非融合编辑器的裁剪功能
                getCutPictureWidthHeight();
            } else {
                // 无论是否是融合编辑器，都要带带上图片的裁剪功能 此处加上一个默认比例
                getFusionEditorCutPictureWidthHeight();
            }
            // 融合编辑器下获取评审意见
            if ($state.params.iwometadataid) {
                getComment($state.params.iwometadataid, $scope.data.comment.currPage);
            }
        }

        /**
         * [getComment description] 获取评审意见
         * @param   {[type]}  id        [id description]
         * @param   {[type]}  currPage  [currPage description]
         * @return  {[type]}            [return description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function (data) {
                if (
                    angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                    $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                    $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
                ) {
                    $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                        $scope.data.comment.comment.length - 1
                    ].times.concat(data.comment[0].times);
                    data.comment.shift();
                }
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [getComment description]获取评审意见
         * @return {[type]} [description]
         */
        $scope.getLoadMoreComment = function () {
            $scope.data.comment.currPage += 1;
            getComment($state.params.iwometadataid, $scope.data.comment.currPage);
        };

        /**
         * [getCutPictureWidthHeight description]获取图片编辑默认宽高
         * @return {[type]} [description]
         */
        function getCutPictureWidthHeight() {
            editingCenterService.querySettedPicSize('app').then(function (data) {
                var pictureSizeArr = ['NEWSPICSIZE', 'FOCUSIMAGESIZE', 'NEWSBIGPICSIZE', 'NEWSZTPICSIZE'];
                var pictureSizeObj = editingCenterAppService.resetPicSize(pictureSizeArr, data);
                // 将返回来的值进行复制到本身控制器里显示
                dealPictureSize(pictureSizeArr, pictureSizeObj);
            });
            if (!$scope.data.imgSize && $scope.list) {
                changeMode($scope.list.LISTSTYLE || '0');
            }
        }

        /**
         * [getFusionEditorCutPictureWidthHeight description]给融合编辑器添加一个默认的比例
         * @return {[type]} [description]
         */
        function getFusionEditorCutPictureWidthHeight() {
            var pictureSizeArr = ['NEWSPICSIZE', 'FOCUSIMAGESIZE', 'NEWSBIGPICSIZE', 'NEWSZTPICSIZE'];
            var pictureSizeObj = editingCenterAppService.resetPicSize(pictureSizeArr);
            // 将返回来的值进行复制到本身控制器里显示
            dealPictureSize(pictureSizeArr, pictureSizeObj);
            if (!$scope.data.imgSize && $scope.list) {
                changeMode($scope.list.LISTSTYLE || '0');
            } else if (!$scope.data.imgSize && !$scope.list) {
                changeMode('0');
            }
        }

        /**
         * [dealPictureSize description]处理图片返回的比例操作
         *
         * @param   {[type]}  pictureSizeArr  [pictureSizeArr description]
         * @param   {[type]}  pictureSizeObj  [pictureSizeObj description]
         *
         * @return  {[type]}                  [return description]
         */
        function dealPictureSize(pictureSizeArr, pictureSizeObj) {
            pictureSizeArr.forEach(function (value, item) {
                $scope.status.pictureSize[value] = pictureSizeObj[value];
            });
            // 定制gulp
            $scope.data.listPicRatio.set = pictureSizeObj.ratio.NEWSPICSIZE;
            $scope.data.focusRatio.set = pictureSizeObj.ratio.FOCUSIMAGESIZE;
            $scope.data.bigPicRtion.set = pictureSizeObj.ratio.NEWSBIGPICSIZE;
            $scope.data.specZtPicRtion.set = pictureSizeObj.ratio.NEWSZTPICSIZE;
        }

        /**
         * [initEditData description]初始化编辑页
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                $scope.list = data;
                $scope.data.remarks = data.REMARKS;
                document.title = data.TITLE;
                if (!data.LISTSTYLE) {
                    $scope.list.LISTSTYLE = '2'; //  网站多元分发过来的新闻、链接、图集稿件，列表样式默认选择文字。
                }
                var dom = document.createElement('div');
                dom.innerHTML = data.HTMLCONTENT;
                $scope.list.HTMLCONTENT = dom.innerHTML;
                $scope.status.audioVideoidsArray = angular.copy($scope.list.VIDEOREL);
                $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                $scope.status.isSecondReview = !!(angular.isDefined(data.ISSECONDREVIEW) && data.ISSECONDREVIEW == '1');
                initKeyWords();
                initRelavantSpecialDoc();
                reWriteImg();
                if ($scope.list.NEWSSOURCES) {
                    $scope.data.manuscriptFrom = 1;
                }
                //  融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                getVersion()
                    .then(function () {
                        return loadDirective();
                    })
                    .then(function () {
                        $scope.status.showVideoAudioDiv = true;
                        defer.resolve();
                    });
                getPropagandaReview();
                syncTitleToListTitle();
            });
            //  稿件加锁
            editIsLock.lockDraft($state.params.appmetadataid);
            return defer.promise;
        }

        /**
         * [initRelavantSpecialDoc description] 初始化相关专题
         * @return {[type]} [description]
         */
        function initRelavantSpecialDoc() {
            if (angular.isDefined($scope.list.RELEVANTSPECIALDOC) && $scope.list.RELEVANTSPECIALDOC.length != 0) {
                angular.forEach($scope.list.RELEVANTSPECIALDOC, function (data, index) {
                    $scope.data.relSubjectSelectedItems.push({
                        METADATAID: data.METADATAID,
                        LISTTITLE: data.LISTTITLE,
                        SPECIALGROUPID: data.SPECIALGROUPID,
                    });
                    $scope.data.relSubjectSelectedGroup.push({
                        name: data.SPECIALGROUPNAME,
                        value: data.SPECIALGROUPID,
                    });
                });
                var i = 0;
                initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
            }

            /**
             * [initRelSubjectGroup description] 初始化相关专题稿件的分组
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            function initRelSubjectGroup(item) {
                var params = {
                    methodname: 'querySpecialGroupsFromData',
                    serviceid: 'mlf_specialgroup',
                    MetaDataId: item.METADATAID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.data.relSubjectGroup[i] = data.DATA;
                    angular.forEach($scope.data.relSubjectGroup[i], function (value, key) {
                        value.name = value.SPECIALGROUPNAME;
                        value.value = value.SPECIALGROUPID;
                    });
                    i++;
                    if (i < $scope.list.RELEVANTSPECIALDOC.length) {
                        initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
                    }
                });
            }
        }

        /**
         * [initNewData description]初始化新页面
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            //  $scope.list = initAddMetaDataService.initNews();
            editingCenterAppService.initTag($state.params.appsiteid).then(function (list) {
                $scope.list = initAddMetaDataService.initNews();
                $scope.list.LABEL = list.length === 0 ? '' : list[0].value;
                //  融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                    $scope.list.LISTTITLE = $scope.list.TITLE; //  融合编辑下将标题复制到列表标题，简化操作
                }
                loadDirective().then(function () {
                    $scope.status.showVideoAudioDiv = true;
                    defer.resolve();
                });
            });
            return defer.promise;
        }

        /**
         * [reWriteImg description]回写图片列表数据
         * @return {[type]} [description]
         */
        function reWriteImg() {
            var imgArray = ['FOCUSIMAGE', 'LISTPICS', 'FIGURE'];
            angular.forEach(imgArray, function (data, index) {
                if ($scope.list[data] !== 0) {
                    var arrayDocPic = [];
                    angular.forEach($scope.list[data], function (dataC, indexC) {
                        arrayDocPic.push({
                            APPFILE: dataC.APPFILE,
                            APPDESC: dataC.APPDESC,
                            PERPICURL: dataC.PERPICURL,
                        });
                    });
                    $scope.list[data] = arrayDocPic;
                }
            });
        }

        /**
         * [loadDirective description] 动态加载
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var defer = $q.defer();
            getBtnRights()
                .then(function () {
                    return getSiteConfig();
                })
                .then(function (data) {
                    if ($state.params.issave === undefined || $state.params.issave === '0') {
                        $scope.status.newFeatures = data.APPMODULEID === undefined ? '' : data.APPMODULEID; // app编辑器新功能；分别为 插入导语 插入组件 插入官员/话题 预览
                        $scope.status.setFont = {
                            //  app编辑器设置字体大小 类型 行距 功能
                            fontFamilyCustom: data.TYPEFACEDEFINITION == '1',
                            fontSize: angular.isDefined(data.EDITORWORDS) ? data.EDITORWORDS.value : '12px',
                            lineSpacing: angular.isDefined(data.ROWSPACINGSETTING) ? data.ROWSPACINGSETTING.value : '1.75',
                        };
                        getUeditor().then(function () {
                            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
                            let supportCreation =
                                '<support-creation is-trs-check-menu="{{\'true\'}}" parent-status="status" big-face-switch="status.bigFaceSwitch" has-editor="true" is-news="true" media-type="{{\'1\'}}" is-check-sensitive-words="status.isCheckSensitiveWords" list="list"></support-creation>';
                            supportCreation = $compile(supportCreation)($scope);
                            $element.find('supportcreation').append(supportCreation);
                            defer.resolve();
                        });
                    } else {
                        defer.resolve();
                    }
                });
            if (!$scope.status.isFusionEditor) {
                var draftList =
                    '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            }
            return defer.promise;
        }

        /**
         * [getCommonUeditor description] 获取普通编辑器
         * @return {[type]} [description]
         */
        function getUeditor() {
            var deffer = $q.defer();
            if ($scope.status.isFusionEditor) {
                let feature = $scope.status.newFeatures.split(',');
                if (feature.indexOf('135插件') < 0) {
                    feature.push('135插件');
                }
                if (feature.indexOf('秀米插件') < 0) {
                    feature.push('秀米插件');
                }
                $scope.status.newFeatures = feature.join(',');
            }
            getIs135Editor()
                .then(
                    function () {
                        return get135Editor($scope.list.PUSHHEADLINETYPE != '2');
                    },
                    function () {
                        return getCommonEditor($scope.list.PUSHHEADLINETYPE != '2');
                    }
                )
                .then(function () {
                    deffer.resolve();
                });

            /**
             * [initListFileData description] 列表图值初始化
             * @param   {[type]}  picData  [picData description]
             * @return  {[type]}           [return description]
             */
            function initListFileData(picData) {
                return {
                    APPFILE: picData.imgName || picData.APPFILE,
                    APPDESC: picData.imgName || picData.APPDESC,
                    PERPICURL: picData.imgSrc || picData.PERPICURL,
                };
            }

            /**
             * [getListFileData description] 获取封面图
             * @param   {[type]}  src  [src description]
             * @return  {[type]}       [return description]
             */
            function getListFileData(src) {
                var flag;
                for (var i = 0, data = $scope.list.LISTPICS; i < data.length; i++) {
                    if (data[i].APPFILE === '') {
                        flag = i + '';
                        break;
                    }
                }
                if ($scope.list.LISTSTYLE === '3') {
                    $scope.list.LISTPICS[0] = initListFileData(src);
                    editingCenterAppService.getImgSize($scope.list.LISTPICS[0].PERPICURL).then(function (size) {
                        $scope.data.listPicRatio.practical[0] = size;
                    });
                    $scope.list.LISTPICS[flag] = initListFileData(src);
                    $scope.data.listPicRatio.practical[flag] = $scope.data.listPicRatio.set[flag];
                } else {
                    if (flag) {
                        $scope.list.LISTPICS[flag] = initListFileData(src);
                    } else {
                        $scope.list.LISTPICS.push(initListFileData(src));
                    }
                    var pos = $scope.list.LISTPICS.length - 1;
                    $scope.data.listPicRatio.practical[pos] = $scope.data.listPicRatio.set[pos];
                }
            }

            /**
             * [listPicFill description] 点击获取列表图的回调
             * @param   {[object]}  src  [src description] 图片信息
             * @return  {[type]}         [return description]
             */
            $scope.listPicFill = function (src) {
                if ($scope.list.LISTSTYLE * 1 === 0 || $scope.list.LISTSTYLE * 1 === 3) { // 不要改为全等 放置
                    if ($scope.list.LISTPICS.length >= 1 && $scope.list.LISTPICS[0].APPFILE) {
                        modalDialog.alertType('列表图已填充满', '', 'warning', 'confirm');
                        return;
                    }
                }
                if ($scope.list.LISTSTYLE * 1 === 1 && $scope.list.LISTPICS.length === 3) {
                    var arr = [];
                    $scope.list.LISTPICS.forEach(function (item, index) {
                        if (item.APPFILE) {
                            arr.push(index);
                        }
                    });
                    if (arr.length === $scope.list.LISTPICS.length) {
                        modalDialog.alertType('列表图已填充满', '', 'warning', 'confirm');
                        return;
                    }
                }
                getListFileData(src);
            };

            /**
             * [getCommonEditor description] 获取普通编辑器
             * @param {string} [compareVersion] [description] 是否进行版本比对
             * @return {[type]} [description]
             */
            function getCommonEditor(compareVersion) {
                var deffer_ = $q.defer();
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                    $scope.status.siteId = $state.params.appsiteid;
                    var ueditor =
                        '<ueditor-for-app edit-flag="editFlag" site-id="{{status.siteId}}" compare-version="' +
                        compareVersion +
                        '" form="newsForm" focus-pic-size="status.pictureSize.FOCUSIMAGESIZE" picture-size="data.imgSize" list-pic-fill="listPicFill" save="previewSave()" type="{{\'app\'}}" new-features="status.newFeatures" set-font="status.setFont" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen" authority="status.btnRights" has-content="status.hasContent"></ueditor-for-app>';
                    ueditor = $compile(ueditor)($scope);
                    $element.find('ueditorLocation').append(ueditor);
                    $scope.status.support.content = $scope.list.CONTENT;
                    $timeout(function () {
                        deffer_.resolve();
                    }, 1500);
                });
                return deffer_.promise;
            }

            $scope.getCommonEditor = getCommonEditor; //  135编辑器切换指令内部使用
            /**
             * [get135Editor description] 获取135编辑器
             * @param {string} [compareVersion] [description] 是否进行版本比对
             * @return {[type]} [description]
             */
            function get135Editor(compareVersion) {
                var deffer__ = $q.defer();
                ueditorService.get135Editor().then(function () {
                    var ueditor =
                        '<editor135 compare-version="' +
                        compareVersion +
                        '" form="newsForm" save="previewSave()" type="{{\'app\'}}" new-features="status.newFeatures" set-font="status.setFont" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen" authority="status.btnRights" has-content="status.hasContent"></editor135>';
                    ueditor = $compile(ueditor)($scope);
                    $element.find('ueditorLocation').append(ueditor);
                    $timeout(function () {
                        deffer__.resolve();
                    }, 1500);
                });
                return deffer__.promise;
            }
            $scope.get135Editor = get135Editor; // 135编辑器切换指令内部使用
            /**
             * [getIs135Editor description] 查询是否启用135编辑器
             * @return {[type]} [description]
             */
            function getIs135Editor() {
                var deffer___ = $q.defer();
                deffer___.reject();
                return deffer___.promise;
            }
            return deffer.promise;
        }

        /**
         * [getBtnRights description] 获取原子权限
         * @return {[type]} [description]
         */
        function getBtnRights() {
            var defer = $q.defer();
            if ($scope.status.isawaitrevise) {
                editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function (rights) {
                    $scope.status.btnRights = rights;
                    defer.resolve();
                });
            } else if (!$scope.status.isFusionEditor) {
                var rightType = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
                editcenterRightsService.initAppListBtn(rightType[$state.params.appplatform], $state.params.appchannelid).then(function (rights) {
                    $scope.status.btnRights = rights;
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [getSiteConfig description]获取站点的配置信息
         * @return {[type]}           [description]
         */
        function getSiteConfig() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'findAppSiteById',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.manuAttr = {
                    relatedTopic: data.RELATEDTOPIC,
                    connectionColumn: data.CONNECTIONCOLUMN,
                    relatedOfficial: data.RELATEDOFFICIAL,
                };
                initRelatedColumnData();
                initRelatedOfficials();
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [initRelatedOfficials description] 初始化相关官员
         * @return {[type]} [description]
         */
        function initRelatedOfficials() {
            if ($scope.status.manuAttr.relatedOfficial != 1) {
                return;
            }
            $scope.status.relatedOfficial = !!(angular.isArray($scope.list.RELEVANTOFFICIALSIDS) && $scope.list.RELEVANTOFFICIALSIDS.length > 0);
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWOfficers',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                $scope.data.relatedOfficialList =
                    angular.isObject(resp) && angular.isObject(resp.DATA) && angular.isArray(resp.DATA.officer_list) ? resp.DATA.officer_list : [];
                if (!angular.isArray($scope.list.RELEVANTOFFICIALSIDS)) {
                    return;
                }
                $scope.data.selectedOfficial = $scope.data.relatedOfficialList.filter((item) =>
                    $scope.list.RELEVANTOFFICIALSIDS.some((_item) => _item == item.id)
                );
            });
        }


        /**
         * [selectedOfficials description] 选中了相关官员
         * @return {[type]} [description]
         */
        $scope.selectedOfficials = function () {
            $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
        };

        /**
         * [initRelatedColumnData description] 初始化相关栏目数据，以适应级联菜单
         * @return {[type]} [description]
         */
        function initRelatedColumnData() {
            if ($scope.status.manuAttr.connectionColumn == 1) {
                $scope.status.relatedColumn = [
                    [
                        {
                            name: $scope.list.BELONGCHANNEL.TYPE,
                            id: $scope.list.BELONGCHANNEL.ID,
                        },
                        {
                            name: $scope.list.BELONGCHANNEL.NAME,
                            id: $scope.list.BELONGCHANNEL.VALUE,
                        },
                    ],
                ];
            }
        }

        /**
         * [getZJXWColumns description] 获取相关栏目列表
         * @return {[type]} [description]
         */
        $scope.getZJXWColumns = function () {
            let deffer = $q.defer();
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWColumns',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                let treeData = (() => {
                    if (
                        !angular.isObject(resp) ||
                        !angular.isObject(resp.DATA) ||
                        !angular.isArray(resp.DATA.all_columns) ||
                        resp.DATA.all_columns.length == 0
                    ) {
                        return [];
                    }
                    return resp.DATA.all_columns.map((item, index) => ({
                        id: item.id,
                        name: item.type,
                        CHILDREN: item.column_list.map((item_, index_) => {
                            item_.hasChildren = 0;
                            return item_;
                        }),
                    }));
                })();
                deffer.resolve(treeData);
            });
            return deffer.promise;
        };

        /**
         * [selectRelatedColumn description] 选中相关栏目
         * @return {[type]} [description]
         */
        $scope.selectRelatedColumn = function () {
            $scope.list.BELONGCHANNEL =
                angular.isArray($scope.status.relatedColumn) &&
                    angular.isArray($scope.status.relatedColumn[0]) &&
                    $scope.status.relatedColumn[0][1].id
                    ? {
                        ID: $scope.status.relatedColumn[0][0].id,
                        TYPE: $scope.status.relatedColumn[0][0].name,
                        NAME: $scope.status.relatedColumn[0][1].name,
                        VALUE: $scope.status.relatedColumn[0][1].id,
                    }
                    : {};
        };

        /**
         * [updateCKSelection description]trsCheckBox的回调函数
         * @param  {[str]} attribute [description]需要改变的属性
         * @return {[type]}           [description]
         */
        $scope.updateCKSelection = function (attribute) {
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };
        //  可视化选择弹窗
        $scope.visualChooseWindow = function (type) {
            trsSelectDocumentService.trsSelectDocument(
                {
                    siteid: $state.params.appsiteid,
                    relNewsData: type === 'relSubjectSelectedItems' ? [] : angular.copy($scope.data[type]),
                    position: $state.params.appplatform,
                    showMetadaId: true,
                    isApp: true,
                    docType: '1',
                    searchSpecialDoc: type == 'relSubjectSelectedItems',
                    isAppNews: type != 'relSubjectSelectedItems',
                    platform: 7,
                },
                function (result) {
                    if (type === 'relNewsSelectedItems') {
                        angular.forEach(result, function (value, key) {
                            value.METADATAID = value.metadataId;
                            value.LISTTITLE = value.title;
                        });
                        $scope.data[type] = result;
                    } else {
                        var i = 0;
                        var index = $scope.data[type].length;
                        var hasGroupArray = [];
                        queryRelSubjectGroup(result[i], function () {
                            $scope.data[type] = $scope.data[type].concat(hasGroupArray);
                        });
                    }

                    /**
                     * [queryRelSubjectGroup description] 请求相关专题稿件的分组
                     * @param  {[type]}   item     [description] 当前稿件
                     * @param  {Function} callback [description] 回调函数
                     * @return {[type]}            [description]
                     */
                    function queryRelSubjectGroup(item, callback) {
                        item.METADATAID = item.metadataId;
                        item.LISTTITLE = item.title;
                        var params = {
                            methodname: 'querySpecialGroupsFromData',
                            serviceid: 'mlf_specialgroup',
                            MetaDataId: item.METADATAID,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                            if (data.DATA.length === 0) {
                                modalDialog.alertType('相关专题"' + item.LISTTITLE + '"没有分组', '', 'error', 'confirm');
                                i++;
                            } else {
                                $scope.data.relSubjectGroup[index] = data.DATA;
                                angular.forEach($scope.data.relSubjectGroup[index], function (value, key) {
                                    value.name = value.SPECIALGROUPNAME;
                                    value.value = value.SPECIALGROUPID;
                                });
                                $scope.data.relSubjectSelectedGroup[index] = $scope.data.relSubjectGroup[index][0];
                                item.SPECIALGROUPID = $scope.data.relSubjectGroup[index][0].SPECIALGROUPID;
                                hasGroupArray.push(item);
                                i++;
                                index++;
                            }
                            if (i < result.length) {
                                queryRelSubjectGroup(result[i], callback);
                            } else {
                                callback();
                            }
                        });
                    }
                }
            );
        };

        /**
         * [queryRelatedNewsByKeyWords description] 查询相关新闻
         * @return {[type]} [description]
         */
        $scope.queryRelatedNewsByKeyWords = function () {
            var DocId = $state.params.appmetadataid ? $state.params.appmetadataid : 0;
            var keywords = [];
            keywords = trsspliceString.spliceString(angular.copy($scope.data.KEYWORDS), 'name', ';');
            if (!keywords) {
                modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                return;
            }
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'queryRelatedNewsByKeyWords',
                MetaDataId: DocId,
                ChannelId: $state.params.appchannelid,
                KeyWords: keywords,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                var ralNewsLen = angular.copy($scope.data.relNewsSelectedItems).length;
                if (ralNewsLen >= 5) {
                    return;
                }
                angular.forEach(data, function (value, key) {
                    value.LISTTITLE = value.TITLE;
                });
                $scope.data.relNewsSelectedItems = darftRemove($scope.data.relNewsSelectedItems, data, 'METADATAID').splice(0, 5);
                if (!$scope.data.relNewsSelectedItems.length) {
                    modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                }
            });
        };

        /**
         * [darftRemove description] 数组去重
         * @param   {[type]}  selectArray  [selectArray description] 当前数组
         * @param   {[type]}  dataArray    [dataArray description] 再次请求出数组
         * @param   {[type]}  type         [type description]
         * @param   {[type]}  callback     [callback description]
         * @return  {[type]}               [return description]
         */
        function darftRemove(selectArray, dataArray, type, callback) {
            var arr = selectArray.concat(dataArray);
            var lastArr = [];
            var num = 0;
            for (var i = 0; i < arr.length; i++) {
                if (!unique(arr[i][type], lastArr, type)) {
                    lastArr.push(arr[i]);
                } else {
                    if (angular.isFunction(callback)) {
                        callback(i - num);
                        num++;
                    }
                }
            }
            return lastArr;
        }

        /**
         * [unique description]
         * @param   {[type]}  n     [n description]
         * @param   {[type]}  arr   [arr description]
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        function unique(n, arr, type) {
            for (var i = 0; i < arr.length; i++) {
                if (n === arr[i][type]) {
                    return true;
                }
            }
            return false;
        }

        // 选择相关新闻或专题
        $scope.selectManuscript = function (item, type) {
            if (type === 'relNewsSelectedItems') {
                if ($scope.data.selectNewArray.indexOf(item) < 0) {
                    $scope.data.selectNewArray.push(item);
                } else {
                    $scope.data.selectNewArray.splice($scope.data.selectNewArray.indexOf(item), 1);
                }
            } else {
                if ($scope.data.selectSubjectArray.indexOf(item) < 0) {
                    $scope.data.selectSubjectArray.push(item);
                } else {
                    $scope.data.selectSubjectArray.splice($scope.data.selectSubjectArray.indexOf(item), 1);
                }
            }
        };

        /**
         * [selectAll description] 稿件全选
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.selectAll = function (type) {
            if (type === 'selectSubjectArray') {
                $scope.data.selectSubjectArray =
                    $scope.data.selectSubjectArray.length == $scope.data.relSubjectSelectedItems.length
                        ? []
                        : [].concat($scope.data.relSubjectSelectedItems);
            } else {
                $scope.data.selectNewArray =
                    $scope.data.selectNewArray.length == $scope.data.relNewsSelectedItems.length ? [] : [].concat($scope.data.relNewsSelectedItems);
            }
        };

        /**
         * [manuscriptDelete description] 删除已选稿件
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.manuscriptDelete = function (type) {
            var index;
            if (type === 'relSubjectSelectedItems') {
                for (var i = 0; i < $scope.data.selectSubjectArray.length; i++) {
                    index = $scope.data.relSubjectSelectedItems.indexOf($scope.data.selectSubjectArray[i]);
                    $scope.data.relSubjectSelectedItems.splice(index, 1);
                }
                $scope.data.selectSubjectArray.length = 0;
            } else {
                for (var i = 0; i < $scope.data.selectNewArray.length; i++) {
                    index = $scope.data.relNewsSelectedItems.indexOf($scope.data.selectNewArray[i]);
                    $scope.data.relNewsSelectedItems.splice(index, 1);
                }
                $scope.data.selectNewArray.length = 0;
            }
        };

        /**
         * [selectRelSubjectGroup description] 选择相关专题稿件的分组
         * @param   {[type]}  item           [item description]
         * @param   {[type]}  selectedGroup  [selectedGroup description]
         * @return  {[type]}                 [return description]
         */
        $scope.selectRelSubjectGroup = function (item, selectedGroup) {
            item.SPECIALGROUPID = selectedGroup.value;
        };

        //  清空相关联稿件
        $scope.cleanRelatedNews = function (type) {
            $scope.data[type] = [];
            if (type === 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup = [];
                $scope.data.relSubjectSelectedGroup = [];
            }
        };

        //  删除相关新闻或专题
        $scope.relNewsDelete = function (curIndex, type) {
            var index = $scope.data[type].indexOf(curIndex);
            $scope.data[type].splice(index, 1);
            if (type === 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            }
        };

        /**
         * [initKeyWords description]初始化关键词
         * @return {[type]} [description]
         */
        function initKeyWords() {
            if ($scope.list.KEYWORDS) {
                var KEYWORDS = $scope.list.KEYWORDS.split(';');
                $scope.data.KEYWORDS = [];
                angular.forEach(KEYWORDS, function (data, index, array) {
                    $scope.data.KEYWORDS.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.KEYWORDS = [];
            }
        }
        //  检验关键词的总个数和总记录长度
        $scope.invalidTag = function (tag) {
            var reg = /^[^<>\/;]*$/;
            if (tag.name.length > 20) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个关键词长度不能超过20！';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符！';
            }
        };
        $scope.checkTag = function (tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len === 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '关键词个数不能超过10个！';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function () {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };
        $scope.leave = function () {
            //  $scope.isShowKeywordTips = false;
        };
        $scope.enter = function () {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                $scope.isShowKeywordTips = true;
            }
        };

        /**
         * [getKeyWords description]获取关键词
         * @return {[type]} [description]
         */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
                if (index != $scope.data.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }
        //  空格增加关键词
        $scope.addkeywords = function (e) {
            if (e.keyCode == 32 && $scope.list.KEYWORDS.indexOf($scope.keywordTxt) < 0) {
                $scope.data.KEYWORDS.push($scope.keywordTxt);
                $scope.keywordTxt = '';
            }
        };
        //  删除关键词
        $scope.delete = function (record) {
            $scope.list.KEYWORDS.splice(record, 1);
        };

        /**
         * [save description] 保存稿件
         * @param  {[type]} type [description] 是否直接保存
         * @return {[type]}      [description]
         */
        $scope.save = function (type) {
            //  包含本地版本功能的稿件类型做了特殊处理，在进行其他操作时均先做此保存操作，以此来更新本地版本
            type = angular.isDefined(type) ? type : true;
            var deffer = $q.defer();
            save(type).then(
                function () {
                    if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'appnews') {
                        if (type === true) {
                            editIsLock.lockDraft($state.params.appmetadataid);
                        }
                        getVersion($scope.list.METADATAID).then(function () {
                            var params;
                            if ($scope.status.isFusionEditor) {
                                params = {
                                    serviceid: 'mlf_fusioncreate',
                                    methodname: 'getAPPFusionDoc',
                                    sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                                };
                            } else {
                                params = {
                                    serviceid: 'mlf_appmetadata',
                                    methodname: 'getNewsDoc',
                                    ChnlDocId: $state.params.appchnldocid,
                                };
                            }
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                                var ue = UE.getEditor('ueditor');
                                ue.ready(function () {
                                    // ue.setContent(data.HTMLCONTENT);
                                    if (!$scope.status.isFusionEditor) {
                                        editcenterRightsService.getRightsofBigFace($state.params.appsiteid, 'appsite.trace').then(function (data) {
                                            $scope.status.bigFaceRights = !!data['appsite.trace.chakan'] ? 'true' : 'false';
                                        });
                                        ueditorService.saveToLocal($scope.list.METADATAID, 'app', data.HTMLCONTENT, $scope.data.lastVersionid);
                                    }
                                    deffer.resolve(data);
                                });
                            });
                        });
                    } else {
                        getVersion($scope.list.METADATAID).then(function () {
                            ueditorService.saveToLocal($scope.list.METADATAID, 'app', $scope.list.HTMLCONTENT, $scope.data.lastVersionid);
                        });
                        deffer.resolve();
                    }
                },
                function (msg) {
                    //  app第二步
                    deffer.reject(msg);
                }
            );
            return deffer.promise;
        };

        /**
         * [saveContent description]保存正文
         * @return {[type]} [description]
         */
        function saveContent() {
            if (!$scope.status.isFusionEditor) {
                ueditorService.saveContent($scope.list);
                if ($scope.list.HTMLCONTENT === '') {
                    $timeout(function () {
                        //  表单校验手动触发
                        $scope.newsForm.content.$error.content = true;
                        $scope.newsForm.content.$valid = false;
                        $scope.newsForm.content.$invalid = true;
                        $scope.newsForm.$error.content = [$scope.newsForm.content];
                        $scope.newsForm.$valid = false;
                        $scope.newsForm.$invalid = true;
                    });
                }
            }
        }

        /**
         * [appTrial description]APP送审操作
         * @return {[type]} [description]
         */
        $scope.appTrial = function () {
            trial();
        };

        /**
         * [trial description]稿件送审
         * @return {[type]} [description]
         */
        function trial() {
            newMediaService.trial($scope, appConst.params.trialParams).then((opinion) => {
                $scope.save(false).then(function () {
                    let trialParams = angular.extend({
                        MetaDataIds: $scope.list.METADATAID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        ChannelId: $state.params.appchannelid,
                        Opinion: opinion,
                    }, appConst.params.trialParams);
                    messagePublishService.publish('doEditPageOperation', trialParams);
                });
            });
        }

        /**
         * [appSignDirect description]app直接签发
         * @return {[type]} [description]
         */
        $scope.appSignDirect = function () {
            signDirect();
        };

        /**
         * [signDirect description] 直接签发
         * @param   {[type]}  isSaveAndPublish  [isSaveAndPublish description]
         * @return  {[type]}                    [return description]
         */
        function signDirect(isSaveAndPublish) {
            var array = [$scope.list];
            if (isSaveAndPublish) {
                signPrivate();
            } else {
                sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, '1').then(
                    function () {
                        signPrivate();
                    },
                    function () {
                        signPrivate();
                    }
                );
            }
        }

        /**
         * [signPrivate description]
         * @return  {[type]}  [return description]
         */
        function signPrivate() {
            var methodname = ['appDaiBianPublish', 'appDaiShenPublish', 'appYiQianFaPublish'];
            $scope.loadingPromise = newMediaService.sign($scope).then(function () {
                $scope.save(false).then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }
        $scope.reportsFilter = function (elm) {
            if (angular.isDefined(elm)) {
                return elm.ISSUCCESS == 'false';
            }
        };
        $scope.successReportsFilter = function (elm) {
            if (angular.isDefined(elm)) {
                return elm.ISSUCCESS == 'true';
            }
        };

        /**
         * [appSignTiming description]定时签发
         * @return {[type]} [description]
         */
        $scope.appSignTiming = function () {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '包含二次送审流程中的稿件,不能定时签发', 'warning', 'confirm', false);
                return;
            }
            var methodname = ['appDaiBianTimingPublish', 'appDaiShenTimingPublish'];
            $scope.loadingPromise = newMediaService.timeSign($scope).then(function () {
                $scope.save(false).then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        };

        /**
         * [appPreview description]稿件预览
         * @return {[type]} [description]
         */
        $scope.appPreview = function () {
            $scope.save(false).then(function (data) {
                editIsLock.lockDraft($state.params.appmetadataid); // 解决预览不是关闭页面而保存已解锁的问题
                mobilePreview();
            });
        };

        /**
         * [mobilePreview description]手机端预览方法
         * @return {[type]} [description]
         */
        function mobilePreview() {
            $scope.loadingPromise = editingCenterAppService.appPrevewPublish($state.params.appchnldocid).then(
                function () { },
                function () {
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            );
        }

        /**
         * [previewSave description]预览前保存，用于编辑器预览
         * @return {[type]} [description]
         */
        $scope.previewSave = function () {
            var deffer = $q.defer();
            $scope.save(false).then(function (data) {
                $scope.status.openBtn = true;
                $state.params.appchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
                $state.params.appmetadataid = $scope.list.METADATAID = data.METADATAID;
                storageListenerService.addListenerToApp('save');
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                editIsLock.lockDraft($state.params.appmetadataid);
                deffer.resolve(data);
            });
            return deffer.promise;
        };

        /**
         * [appRevoke description]稿件撤稿
         * @return {[type]} [description]
         */
        $scope.appRevoke = function () {
            // $scope.save(false).then(function (data) {
            revoke();
            // });
        };

        /**
         * [revoke description]撤稿函数
         * @return {[type]} [description]
         */
        function revoke() {
            newMediaService.rejection($scope, appConst.params.rejectionParams).then((opinion) => {
                $scope.save(false).then(function () {
                    let KillParams = angular.extend({
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                        Opinion: opinion,
                        ChannelId: $state.params.appchannelid,
                    }, appConst.params.rejectionParams);
                    messagePublishService.publish('doEditPageOperation', KillParams);
                });
            });
            // modalDialog.inputModel(
            //     '撤稿',
            //     '撤稿原因（选填）',
            //     function (content) {
            //         var params = {
            //             serviceid: 'mlf_appoper',
            //             methodname: 'rejectionMetaDatas',
            //             ChnlDocIds: $scope.list.CHNLDOCID,
            //             MetaDataIds: $scope.list.METADATAID,
            //             Opinion: content,
            //             ChannelId: $state.params.appchannelid,
            //         };
            //         trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', false).then(
            //             function () {
            //                 modalDialog.alertType(
            //                     '撤稿成功',
            //                     '',
            //                     'success',
            //                     false,
            //                     function () {
            //                         $scope.status.isSignedOrRevoked = true;
            //                         storageListenerService.addListenerToApp('revoke');
            //                         $window.close();
            //                     },
            //                     '',
            //                     1500
            //                 );
            //             },
            //             function () {
            //                 editIsLock.lockDraft($state.params.appmetadataid);
            //             }
            //         );
            //     },
            //     '',
            //     function () {
            //         editIsLock.lockDraft($state.params.appmetadataid);
            //     }
            // );
        }

        /**
         * [appSavePublish description]保存并发布
         * @return {[type]} [description]
         */
        $scope.appSavePublish = function () {
            signDirect(true);
        };

        /**
         * [revise description] 修订
         * @return {[type]} [description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                save().then(
                    function () {
                        var params = {
                            serviceid: 'mlf_modifydoc',
                            methodname: 'paperModifyDocsFinished',
                            PaperDocIds: $state.params.appmetadataid,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                modalDialog.alertType(
                                    '修订成功',
                                    '',
                                    'success',
                                    false,
                                    function () {
                                        storageListenerService.addListenerToNewspaper('xiuding');
                                        $window.close();
                                    },
                                    '',
                                    1500
                                );
                            },
                            function (data) {
                                editIsLock.lockDraft($state.params.appmetadataid);
                            }
                        );
                    },
                    function () {
                        editIsLock.lockDraft($state.params.appmetadataid);
                    }
                );
            });
        };

        /**
         * [dealAttributeBeforeSave description]保存前处理保存属性
         * @return {[obj]} [description]list对象
         */
        function dealAttributeBeforeSave() {
            $scope.status.openBtn = false;
            getKeyWords();
            $scope.list.RELATEDNEWS = trsspliceString.spliceString($scope.data.relNewsSelectedItems, 'METADATAID', ',');
            $scope.list.SPECIALMANUSCRIPT = $scope.data.specialManuscript;
            //  根据列表样式过滤多余的图片信息
            if ($scope.list.LISTSTYLE == '2') {
                $scope.list.LISTPICS = [];
            } else if ($scope.list.LISTSTYLE == '0') {
                $scope.list.LISTPICS = [].concat(angular.copy($scope.list.LISTPICS[0]));
            }
            $scope.list.CONTRIBUTORSAUTHER = $scope.data.userName;
            $scope.list.FIGURE = $scope.list.ISSELECTFIGURE == '0' ? [] : $scope.list.FIGURE;
            $scope.list.CUSTOMTIME = globleParamsSet.filterTime($scope.list.CUSTOMTIME, 'yyyy-MM-dd HH:mm');
            getRelavantSpecialDoc();
            var list = angular.copy($scope.list);
            list.LISTPICS = angular.copy(jsonArrayToStringService.clearEmptyArray(list.LISTPICS));
            // 处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined(list.FGD_AUTHINFO[0]) &&
                (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
            ) {
                list.FGD_AUTHINFO = [];
            }
            list.ORIGINALTYPE = $scope.data.originType;
            list.SPECIALDOC = $scope.data.specialDoc;
            // 处理发稿单作者信息空数据提交问题
            if ($scope.status.isFusionEditor) {
                delete list.ISNOPAYMENT;
                delete list.FGD_EDITINFO;
                delete list.FGD_AUTHINFO;
                delete list.DOCGENRE;
                list.METADATAID = $state.params.appmetadataid || '0';
                list.serviceid = 'mlf_fusionapp';
                list.methodname = 'saveFictitiousNewsDoc';
                list.SourceDocId = $scope.data.sourceDocId || $state.params.iwometadataid;
            } else {
                list.serviceid = 'mlf_appmetadata';
                list.methodname = 'saveNewsDoc';
            }
            list = jsonArrayToStringService.jsonArrayToString(list);
            return list;
        }

        /**
         * [getRelavantSpecialDoc description] 获取相关专题
         * @return {[type]} [description]
         */
        function getRelavantSpecialDoc() {
            darftRemove($scope.data.relSubjectSelectedItems, [], 'SPECIALGROUPID', function (index) {
                $scope.data.relSubjectSelectedItems.splice(index, 1);
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            });
            $scope.list.RELEVANTSPECIALDOC = [];
            angular.forEach($scope.data.relSubjectSelectedItems, function (data, index) {
                $scope.list.RELEVANTSPECIALDOC.push({
                    METADATAID: data.METADATAID,
                    SPECIALGROUPID: data.SPECIALGROUPID,
                });
            });
            $scope.list.RELEVANTSPECIALDOC = jsonArrayToStringService.clearEmptyArray($scope.list.RELEVANTSPECIALDOC);
        }

        /**
         * [dealAttributeAfterSave description]保存成功后处理属性
         * @param  {[obj]} data [description]保存后后台返回值
         * @param  {[boolean]} flag [description]标识位
         * @return {[type]}      [description]
         */
        function dealAttributeAfterSave(data, flag) {
            $scope.status.openBtn = true;
            $scope.status.isEditDraft = true;
            $state.params.appchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
            $state.params.appmetadataid = $scope.list.METADATAID = data.METADATAID;
            if (flag) {
                if (!$scope.status.isFusionEditor) {
                    storageListenerService.addListenerToApp('save');
                    $state.transitionTo($state.current, $state.params, {
                        reload: false,
                    });
                    $timeout(function () {
                        modalDialog.saveModel('保存成功', '', 'success');
                    }, 500);
                }
                // editingCenterService.upDateVideoRelation($scope.data.editorDetail, $scope.data.METADATAID, $scope.list.TITLE, $scope.status.isFusionEditor);
            } else {
                $scope.params.MetaDataIds = $scope.list.METADATAID;
                $scope.params.CHNLDOCIDS = $scope.list.CHNLDOCID;
                $scope.params.ObjectIds = $scope.list.CHNLDOCID;
                $scope.params.serviceid = 'mlf_appoper';
            }
        }

        /**
         * [save description]保存方法
         * @param  {[boolean]} flag [description]标示位
         * @return {[type]}      [description]
         */
        function save(flag) {
            var deferred = $q.defer();
            $scope.status.isedit = !!$state.params.appmetadataid;
            saveContent();
            $validation.validate($scope.newsForm.authorForm);
            $scope.newsForm.$pending = {};
            $validation
                .validate($scope.newsForm)
                .success(function () {
                    editingCenterAppService
                        .examineImageRatio($scope.list, $scope.data, $scope.status, 'NEWSPICSIZE', 'NEWSBIGPICSIZE', 'NEWSZTPICSIZE')
                        .then(function () {
                            modalDialog.isSecretInformation(
                                $state.params.appmetadataid,
                                function () {
                                    sensitiveWordCheckService.sensitiveWords($scope).then(
                                        function (sensitiveWords) {
                                            $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                            $scope.list.SENSITIVEWORDS = sensitiveWords;
                                            if (angular.isDefined($scope.list.EXTPROPERTY)) {
                                                $scope.list.EXTPROPERTY.SENSITIVEWORDS = sensitiveWords;
                                            } else {
                                                $scope.list.EXTPROPERTY = {
                                                    SENSITIVEWORDS: sensitiveWords,
                                                };
                                            }
                                            $scope.newsForm.$setPristine();
                                            var list = dealAttributeBeforeSave();
                                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                                function (data) {
                                                    $scope.data.METADATAID = data.METADATAID;
                                                    if (!$scope.status.isedit) {
                                                        $scope.status.isedit = false;
                                                    } else {
                                                        $scope.status.isedit = true;
                                                    }
                                                    dealAttributeAfterSave(data, flag);
                                                    beforeonload.refresh($scope);
                                                    deferred.resolve(data);
                                                },
                                                function (data) {
                                                    $scope.status.openBtn = true;
                                                    deferred.reject();
                                                }
                                            );
                                        },
                                        function () {
                                            $scope.status.isCheckSensitiveWords = Math.random();
                                            deferred.reject();
                                        }
                                    );
                                },
                                function () {
                                    deferred.reject();
                                },
                                $scope.status.isFusionEditor
                            );
                        });
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.newsForm, $element, $scope); // 定位输入错的表单位置
                    // app第一步
                    deferred.reject({ plat: '客户端' });
                });
            return deferred.promise;
        }

        /**
         * [getVersion description] 获取流程版本与操作日志
         * @param   {[type]}  id  [id description]
         * @return  {[type]}      [return description]
         */
        function getVersion(id) {
            var deffer = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $state.params.appmetadataid;
            metadataid = $state.params.iwometadataid ? $state.params.iwometadataid : metadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deffer.resolve();
                },
                function () {
                    deffer.resolve();
                }
            );
            return deffer.promise;
        }
        $scope.getVersionTitle = function () {
            var title = false;
            for (var key in $scope.data.version.operationLog) {
                if ($scope.data.version.operationLog[key].length > 0) {
                    title = true;
                    break;
                }
            }
            return title;
        };

        $scope.getVersionTitle = function () {
            var title = false;
            for (var key in $scope.data.version.operationLog) {
                if ($scope.data.version.operationLog[key].length > 0) {
                    title = true;
                    break;
                }
            }
            return title;
        };

        /**
         * [getPropagandaReview description] 获取宣传部评审流程
         * @return  {[type]}  [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview(1, $state.params.appmetadataid).then(function (data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function (key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };

        /**
         * [clickCommonAuthor description] 添加作者快速功能
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.clickCommonAuthor = function (item) {
            $scope.list.SIGNATUREAUTHOR += item.text;
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [deleteUploaderImg description]删除上传后的图片
         * @param  {[str]} attribute [description]要删除的属性
         * @param  {[num]} index     [description]下标
         * @return {[type]}           [description]
         */
        $scope.deleteUploaderImg = function (attribute, index) {
            if (attribute === 'LISTPICS') {
                $scope.list[attribute][index] = {
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                };
            } else {
                $scope.list[attribute] = [];
            }
        };

        /**
         * [getKeywordsOrAbstract description]提取关键词或摘要
         * @param  {[str]} type [description]关键词类型或摘要
         * @return {[type]}      [description]
         */
        $scope.getKeywordsOrAbstract = function (type) {
            editingCenterService.getKeywordsOrAbstract(type, ueditorService.bindContentForKeyword()).then(
                function (data) {
                    if (type === 'keywords') {
                        if (data !== '""') {
                            var arr = [];
                            var keywordsArray = data.substring(1, data.length - 1).split(';');
                            angular.forEach(keywordsArray, function (value, key) {
                                arr.push({
                                    name: value,
                                });
                            });
                            $scope.data.KEYWORDS = angular.isArray($scope.data.KEYWORDS) ? $scope.data.KEYWORDS : [];
                            $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                            $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                            if ($scope.data.KEYWORDS.length > 10) {
                                $scope.data.KEYWORDS = $scope.data.KEYWORDS.splice(0, 10);
                            }
                        } else {
                            return;
                        }
                    }
                    if (type === 'abstract') {
                        $scope.list.ABSTRACT = data.substring(1, data.length - 1);
                    }
                },
                function (data) { }
            );
        };

        /**
         * [clearAllKeywords description]清楚关键词
         * @return {[type]} [description]
         */
        $scope.clearAllKeywords = function () {
            $scope.data.KEYWORDS = [];
        };

        /**
         * [initBtnArray description]初始化功能按钮
         * @return {[type]} [description]
         */
        function initBtnArray() {
            if ($scope.status.isawaitrevise) {
                // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                addBtn();
                return;
            }
            // 所需的按钮
            $scope.data.appRequiredBtns = initAppRequiredBtnService.initAppRequiredBtns()[$state.params.appplatform];
            // 根据不同平台调用不同权限方法
            $scope.data.rightsMethod = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
            initeditctrBtnsService.initAppData($state.params.appchannelid, $scope.data.rightsMethod[$state.params.appplatform]).then(function (data) {
                // 字典按钮
                $scope.data.dictionaryBtn = [
                    appDictionaryBtnService.initAppCompBtn(),
                    appDictionaryBtnService.initAppPendBtn(),
                    appDictionaryBtnService.initAppSignBtn(),
                ];
                initeditctrBtnsService.initBtns(data, $scope.data.dictionaryBtn[$state.params.appplatform]).then((btns) => {
                    $scope.status.btnStatus = btns;
                    $scope.data.arrayBtn = filterEditctrBtnsService.filterBtn($scope.status.btnStatus, $scope.data.appRequiredBtns);
                    addBtn();
                });
            });
        }

        /**
         * [addBtn description] 新增保存关闭按钮
         * @return  {[type]}  [return description]
         */
        function addBtn() {
            $scope.data.arrayBtn = $scope.data.arrayBtn ? $scope.data.arrayBtn : [];
            var OPERDESC = ['保存', '保存'];
            var OPERFUN = ['save', 'save'];
            if ($state.params.appplatform < 2) {
                $scope.data.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: OPERDESC[$state.params.appplatform],
                    OPERNAME: '',
                    OPERFUN: OPERFUN[$state.params.appplatform],
                });
            }
        }

        /**
         * [appSecondReview description] 已签发平台二次送审
         * @return {[type]} [description]
         */
        $scope.appSecondReview = function () {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能重复送审', 'warning', 'confirm');
                return;
            }
            modalDialog.confirmModal('二次送审', '确认送审稿件', function () {
                appSecondReview();
            });
        };

        /**
         * [appSecondReview description] 二次送审函数(不做保存，但把保存方法里的稿件信息全部作为参数传过去)
         * @param  {[type]} metadataid [description]
         * @return {[type]}            [description]
         */
        function appSecondReview() {
            saveContent(); // 保存文本内容
            $validation.validate($scope.newsForm.authorForm);
            $scope.newsForm.$pending = {};
            $validation
                .validate($scope.newsForm)
                .success(function () {
                    sensitiveWordCheckService.sensitiveWords($scope).then(
                        function (sensitiveWords) {
                            $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                            $scope.list.SENSITIVEWORDS = sensitiveWords;
                            if (angular.isDefined($scope.list.EXTPROPERTY)) {
                                $scope.list.EXTPROPERTY.SENSITIVEWORDS = sensitiveWords;
                            } else {
                                $scope.list.EXTPROPERTY = {
                                    SENSITIVEWORDS: sensitiveWords,
                                };
                            } // 校验敏感词
                            $scope.newsForm.$setPristine();
                            // 保存前处理保存属性
                            var list = dealAttributeBeforeSave();
                            list.serviceid = 'mlf_appoper';
                            list.methodname = 'makeNewDuplication';
                            list.MetaDataId = list.METADATAID;
                            list.ChannelId = list.CHANNELID;
                            delete list.METADATAID; // 传参类型为驼峰型，删除之前纯大写字段；
                            delete list.CHANNELID;
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                function (data) {
                                    if (data.ISSUCCESS == 'true') {
                                        getVersion($scope.list.METADATAID).then(function () {
                                            var params = {
                                                serviceid: 'mlf_appmetadata',
                                                methodname: 'getNewsDoc',
                                                ChnlDocId: $state.params.appchnldocid,
                                            };
                                            $scope.loadingPromise = trsHttpService
                                                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                                                .then(function (data) {
                                                    var ue = UE.getEditor('ueditor');
                                                    ue.ready(function () {
                                                        ue.setContent(data.HTMLCONTENT);
                                                        editcenterRightsService
                                                            .getRightsofBigFace($state.params.appsiteid, 'appsite.trace')
                                                            .then(function (data) {
                                                                $scope.status.bigFaceRights = !!data['appsite.trace.chakan'] ? 'true' : 'false';
                                                            });
                                                        ueditorService.saveToLocal(
                                                            $scope.list.METADATAID,
                                                            'app',
                                                            data.HTMLCONTENT,
                                                            $scope.data.lastVersionid
                                                        );
                                                        modalDialog.alertType(
                                                            '二次送审成功',
                                                            '',
                                                            'success',
                                                            false,
                                                            function () {
                                                                $scope.status.isSecondReview = true;
                                                                storageListenerService.addListenerToApp('secondReview');
                                                                $window.close();
                                                            },
                                                            '',
                                                            1500
                                                        );
                                                    });
                                                });
                                        });
                                    } else {
                                        modalDialog.alertType('二次送审失败', data.message, 'error', 'confirm');
                                    }
                                },
                                function (data) {
                                    $scope.status.openBtn = true;
                                    modalDialog.alertType('二次送审失败', data.message, 'error', 'confirm');
                                }
                            );
                        },
                        function () {
                            $scope.status.isCheckSensitiveWords = Math.random();
                        }
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.newsForm); // 定位输入错的表单位置
                });
        }

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {};
            if (!!$state.params.iwometadataid) {
                geRelatedversion($state.params.iwometadataid, item.VERSIONNUM).then(function (data) {
                    var params = {
                        // 融合
                        metadataid: $state.params.iwometadataid,
                        iwoobjectversionid: item.OBJECTVERSIONID,
                        wzobjectversionid: angular.isDefined(data.web) ? data.web.objversionId : '',
                        bzobjectversionid: angular.isDefined(data.paper) ? data.paper.objversionId : '',
                        appobjectversionid: angular.isDefined(data.app) ? data.app.objversionId : '',
                        wxobjectversionid: angular.isDefined(data.wechat) ? data.wechat.objversionId : '',
                        versionum: item.VERSIONNUM,
                    };
                    item.url = $state.href(path, params);
                    var url = item.url;
                    $window.open(url);
                });
            } else {
                var objName = $scope.data.versionName[item.MEDIATYPE];
                params[objName] = item.OBJECTVERSIONID;
                params['metadataid'] = $state.params.appmetadataid;
                item.url = $state.href(path, params);
                var url = item.url;
                $window.open(url);
            }
        };

        /**
         * [geRelatedversion description] 融合稿获取关联流程版本
         * @param  {[type]} MetaDataId [description]
         * @param  {[type]} num        [description]
         * @return {[type]}            [description]
         */
        function geRelatedversion(MetaDataId, num) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_fusionmyrelease',
                methodname: 'getObjversionByDoc',
                METADATAID: MetaDataId,
                VersionNum: num,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /* 融合编辑器额外功能开始*/
        if ($scope.status.isFusionEditor) {

            /**
             * [pageCantEdit description] 已提交渠道编辑页不能编辑
             * @param  {[type]} type [description] 稿件信息或属性信息
             * @return {[type]}      [description]
             */
            $scope.pageCantEdit = function (type) {
                $timeout(function () {
                    if (type === 'manuscriptInfo') {
                        var manuHeight = $('.app_manuscript_info').height();
                        var manuWidth = $('.app_manuscript_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(manuHeight)
                            .width(manuWidth);
                        $('.app_manuscript_info').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    } else if (type == 'attrInfo') {
                        var attrHeight = $('.app_attr_info').height();
                        var attrWidth = $('.app_attr_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(attrHeight)
                            .width(attrWidth);
                        $('.app_attr_info').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    }
                }, 300);
            };
        }

        /**
         * [initData description] 融合编辑器切换渠道时的初始化数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if (angular.isDefined($state.params.appchnldocid)) {
                initEditData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };

        /**
         * [loadFgd description] 加载发稿单
         * @return {[type]} [description]
         */
        $scope.loadFgd = function () {
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        };

        /* 融合编辑器额外功能结束*/

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题]
         *
         * @return  {[type]}  [return description]
         */
        $scope.syncTitleToListTitle = function () {
            syncTitleToListTitle();
        };

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题实现]
         *
         * @return  {[type]}  [return description]
         */
        function syncTitleToListTitle() {
            if ($scope.status.hasTitleSynced) {
                return;
            } else {
                if ($scope.list.LISTTITLE !== '') {
                    return;
                } else {
                    $scope.list.LISTTITLE = $scope.list.TITLE;
                    $scope.status.hasTitleSynced = true;
                }
            }
        }

        /**
         * [changeMode description] 列表图模式切换，html调用
         *
         * @param   {[type]}  listStyle  [listStype description]
         *
         * @return  {[type]}             [return description]
         */
        $scope.changeMode = function (listStyle) {
            $scope.list.LISTSTYLE = listStyle.value;
            changeMode(listStyle.value);
        };

        /**
         * [changeMode description] js内部调用
         *
         * @param   {[type]}  value  [listStype description]
         *
         * @return  {[type]}  [return description]
         */
        function changeMode(value) {
            if ($scope.status.pictureSize) {
                switch (value) {
                    case '0':
                        $scope.data.imgSize = $scope.status.pictureSize.NEWSPICSIZE;
                        break;
                    case '3':
                        $scope.data.imgSize = $scope.status.pictureSize.NEWSBIGPICSIZE;
                        break;
                    case '1':
                        $scope.data.imgSize = $scope.status.pictureSize.NEWSPICSIZE;
                        break;
                    case '4':
                        $scope.data.imgSize = $scope.status.pictureSize.NEWSZTPICSIZE;
                        break;
                }
            }
        }

        /**
         * [closeWindow description] 关闭窗口
         * @return  {[type]}  [return description]
         */
        $scope.closeWindow = function () {
            editingCenterService.closeWindow('app', $scope);
        };

        /**
         * [saveAndClose description] 保存内容并关闭窗口
         * @return  {[type]}  [return description]
         */
        $scope.saveAndClose = function () {
            $scope.save(false).then(function () {
                window.close();
            });
        };

        /**
         * [getZrbj description] 责任编辑复制
         * @return  {[type]}  [return description]
         */
        function getZrbj() {
            let trueName = $sessionStorage.get('curUserInfo').TRUENAME;
            $scope.list.RESPONSIBLEEDITOR = $scope.list.RESPONSIBLEEDITOR ? $scope.list.RESPONSIBLEEDITOR : trueName;
        }
    },
]);
